module.exports = __webpack_public_path__ + "img/2-3.be1c9c87.jpg";